<template>
  <div class="hzc-discuss">
    <div class="mask" @click="closeIndustrial"></div>
    <div class="content">
      <p class="banner-title">{{ date }}</p>
      <div class="data1"><span>{{ detail.data1['druidParamName'] }}<em v-if="detail.data1['price'] !== ''">:</em></span> <span style="color:#48FFFF;">{{detail.data1['price']}}</span></div>
      <div class="data2"><span>{{ detail.data2['druidParamName'] }}<em v-if="detail.data2['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data2['price']}}</span></div>
      <div class="data3"><span>{{ detail.data3['druidParamName'] }}<em v-if="detail.data3['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data3['price']}}</span></div>
      <div class="data4"><span>{{ detail.data4['druidParamName'] }}<em v-if="detail.data4['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data4['price']}}</span>
      </div>
      <div class="data5"><span>{{ detail.data5['druidParamName'] }}<em v-if="detail.data5['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data5['price']}}</span>
      </div>
      <div class="data6"><span>{{ detail.data6['druidParamName'] }}<em v-if="detail.data6['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data6['price']}}</span>
      </div>
      <div class="data7"><span>{{ detail.data7['druidParamName'] }}<em v-if="detail.data7['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data7['price']}}</span>
      </div>
      <div class="data8"><span>{{ detail.data8['druidParamName'] }}<em v-if="detail.data8['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data8['price']}}</span>
      </div>
      <div class="data9"><span>{{ detail.data9['druidParamName'] }}<em v-if="detail.data9['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data9['price']}}</span>
      </div>
      <div class="data10"><span>{{ detail.data10['druidParamName'] }}<em v-if="detail.data10['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data10['price']}}</span>
      </div>
      <div class="data11"><span>{{ detail.data11['druidParamName'] }}<em v-if="detail.data11['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data11['price']}}</span>
      </div>
      <div class="data12"><span>{{ detail.data12['druidParamName'] }}<em v-if="detail.data12['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data12['price']}}</span>
      </div>
      <div class="data13"><span>{{ detail.data13['druidParamName'] }}<em v-if="detail.data13['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data13['price']}}</span>
      </div>
      <div class="data14"><span>{{ detail.data14['druidParamName'] }}<em v-if="detail.data14['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data14['price']}}</span>
      </div>
      <div class="data15"><span>{{ detail.data15['druidParamName'] }}<em v-if="detail.data15['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data15['price']}}</span>
      </div>
      <div class="data16"><span>{{ detail.data16['druidParamName'] }}<em v-if="detail.data16['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data16['price']}}</span>
      </div>
      <div class="data17"><span>{{ detail.data17['druidParamName'] }}<em v-if="detail.data17['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data17['price']}}</span>
      </div>
      <div class="data18"><span>{{ detail.data18['druidParamName'] }}<em v-if="detail.data18['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data18['price']}}</span>
      </div>
      <div class="data19"><span>{{ detail.data19['druidParamName'] }}<em v-if="detail.data19['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data19['price']}}</span>
      </div>
      <div class="data20"><span>{{ detail.data20['druidParamName'] }}<em v-if="detail.data20['price'] !== ''">:</em></span><span style="color:#48FFFF;">{{detail.data20['price']}}</span>
      </div>
      <div class="differPrice1 redColor" v-if="detail['price']['differPrice1'] > 0">
        {{ '+' + detail['price']['differPrice1'] }}
      </div>
      <div class="differPrice1 greenColor" v-if="detail['price']['differPrice1'] < 0">{{ detail['price']['differPrice1'] }}
      </div>
      <div class="differPrice1" v-if="detail['price']['differPrice1'] === 0">—</div>
      <div class="differPrice2 redColor" v-if="detail['price']['differPrice2'] > 0">
        {{ '+' + detail['price']['differPrice2'] }}
      </div>
      <div class="differPrice2 greenColor" v-if="detail['price']['differPrice2'] < 0">{{ detail['price']['differPrice2'] }}
      </div>
      <div class="differPrice2" v-if="detail['price']['differPrice2'] === 0">—</div>
      <div class="differPrice3 redColor" v-if="detail['price']['differPrice3'] > 0">
        {{ '+' + detail['price']['differPrice3'] }}
      </div>
      <div class="differPrice3 greenColor" v-if="detail['price']['differPrice3'] < 0">{{ detail['price']['differPrice3'] }}
      </div>
      <div class="differPrice3" v-if="detail['price']['differPrice3'] === 0">—</div>
      <div class="differPrice4 redColor" v-if="detail['price']['differPrice4'] > 0">
        {{ '+' + detail['price']['differPrice4'] }}
      </div>
      <div class="differPrice4 greenColor" v-if="detail['price']['differPrice4'] < 0">{{ detail['price']['differPrice4'] }}
      </div>
      <div class="differPrice4" v-if="detail['price']['differPrice4'] === 0">—</div>
      <div class="differPrice5 redColor" v-if="detail['price']['differPrice5'] > 0">
        {{ '+' + detail['price']['differPrice5'] }}
      </div>
      <div class="differPrice5 greenColor" v-if="detail['price']['differPrice5'] < 0">{{ detail['price']['differPrice5'] }}
      </div>
      <div class="differPrice5" v-if="detail['price']['differPrice4'] === 0">—</div>
      <div class="differPrice6 redColor" v-if="detail['price']['differPrice6'] > 0">
        {{ '+' + detail['price']['differPrice6'] }}
      </div>
      <div class="differPrice6 greenColor" v-if="detail['price']['differPrice6'] < 0">{{ detail['price']['differPrice6'] }}
      </div>
      <div class="differPrice6" v-if="detail['price']['differPrice6'] === 0">—</div>
      <div class="differPrice7 redColor" v-if="detail['price']['differPrice7'] > 0">
        {{ '+' + detail['price']['differPrice7'] }}
      </div>
      <div class="differPrice7 greenColor" v-if="detail['price']['differPrice7'] < 0">{{ detail['price']['differPrice7'] }}
      </div>
      <div class="differPrice7" v-if="detail['price']['differPrice7'] === 0">—</div>
      <div class="differPrice8 redColor" v-if="detail['price']['differPrice8'] > 0">
        {{ '+' + detail['price']['differPrice8'] }}
      </div>
      <div class="differPrice8 greenColor" v-if="detail['price']['differPrice8'] < 0">{{ detail['price']['differPrice8'] }}
      </div>
      <div class="differPrice8" v-if="detail['price']['differPrice8'] === 0">—</div>
      <div class="differPrice9 redColor" v-if="detail['price']['differPrice9'] > 0">
        {{ '+' + detail['price']['differPrice9'] }}
      </div>
      <div class="differPrice9 greenColor" v-if="detail['price']['differPrice9'] < 0">{{ detail['price']['differPrice9'] }}
      </div>
      <div class="differPrice9" v-if="detail['price']['differPrice9'] === 0">—</div>
      <div class="differPrice10 redColor" v-if="detail['price']['differPrice10'] > 0">
        {{ '+' + detail['price']['differPrice10'] }}
      </div>
      <div class="differPrice10 greenColor" v-if="detail['price']['differPrice10'] < 0">{{ detail['price']['differPrice10'] }}
      </div>
      <div class="differPrice10" v-if="detail['price']['differPrice10'] === 0">—</div>
      <div class="differPrice11 redColor" v-if="detail['price']['differPrice11'] > 0">
        {{ '+' + detail['price']['differPrice11'] }}
      </div>
      <div class="differPrice11 greenColor" v-if="detail['price']['differPrice11'] < 0">{{ detail['price']['differPrice11'] }}
      </div>
      <div class="differPrice11" v-if="detail['price']['differPrice11'] === 0">—</div>
      <div class="differPrice12 redColor" v-if="detail['price']['differPrice12'] > 0">
        {{ '+' + detail['price']['differPrice12'] }}
      </div>
      <div class="differPrice12 greenColor" v-if="detail['price']['differPrice12'] < 0">{{ detail['price']['differPrice12'] }}
      </div>
      <div class="differPrice12" v-if="detail['price']['differPrice12'] === 0">—</div>
      <div class="differPrice13 redColor" v-if="detail['price']['differPrice13'] > 0">
        {{ '+' + detail['price']['differPrice13'] }}
      </div>
      <div class="differPrice13 greenColor" v-if="detail['price']['differPrice13'] < 0">{{ detail['price']['differPrice13'] }}
      </div>
      <div class="differPrice13" v-if="detail['price']['differPrice13'] === 0">—</div>
      <div class="differPrice14 redColor" v-if="detail['price']['differPrice14'] > 0">
        {{ '+' + detail['price']['differPrice14'] }}
      </div>
      <div class="differPrice14 greenColor" v-if="detail['price']['differPrice14'] < 0">{{ detail['price']['differPrice14'] }}
      </div>
      <div class="differPrice14" v-if="detail['price']['differPrice14'] === 0">—</div>
      <div class="differPrice15 redColor" v-if="detail['price']['differPrice15'] > 0">
        {{ '+' + detail['price']['differPrice15'] }}
      </div>
      <div class="differPrice15 greenColor" v-if="detail['price']['differPrice15'] < 0">{{ detail['price']['differPrice15'] }}
      </div>
      <div class="differPrice15" v-if="detail['price']['differPrice15'] === 0">—</div>
      <div class="differPrice16 redColor" v-if="detail['price']['differPrice16'] > 0">
        {{ '+' + detail['price']['differPrice16'] }}
      </div>
      <div class="differPrice16 greenColor" v-if="detail['price']['differPrice16'] < 0">{{ detail['price']['differPrice16'] }}
      </div>
      <div class="differPrice16" v-if="detail['price']['differPrice16'] === 0">—</div>
      <div class="differPrice17 redColor" v-if="detail['price']['differPrice17'] > 0">
        {{ '+' + detail['price']['differPrice17'] }}
      </div>
      <div class="differPrice17 greenColor" v-if="detail['price']['differPrice17'] < 0">{{ detail['price']['differPrice17'] }}
      </div>
      <div class="differPrice17" v-if="detail['price']['differPrice17'] === 0">—</div>
      <div class="differPrice18 redColor" v-if="detail['price']['differPrice18'] > 0">
        {{ '+' + detail['price']['differPrice18'] }}
      </div>
      <div class="differPrice18 greenColor" v-if="detail['price']['differPrice18'] < 0">{{ detail['price']['differPrice18'] }}
      </div>
      <div class="differPrice18" v-if="detail['price']['differPrice18'] === 0">—</div>
    </div>
  </div>
</template>

<script>
import {bigChainList} from "@/api";

export default {
  data() {
    return {
      detail:{},
      date:''
    }
  },
  created() {
    this.getDetail()
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow:hidden')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      bigChainList({dictDataType:'issue_material_chain'}).then(res => {
        this.detail = res.data;
        let data1 = this.detail['data1'];
        this.date = data1['date']
      })
    },
    /**
     * 关闭
     */
    closeIndustrial(val) {
      this.$emit('closeIndustrialCh', val);
    },
  }
}
</script>

<style lang="less" scoped>
.hzc-discuss {
  z-index: 101;
  width: 1194px;
  height: 730px;
  background-color: #fff;

  .confirm {
    position: fixed;
    right: 10px;
    top: 10px;
    z-index: 110;
    width: 50px;
    cursor: pointer;
  }

  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  .content {
    width: 1194px;
    height: 730px;
    display: inline-block;
    background: url("../../assets/home/materialBig.png");
    background-size: 100% 100%;
    color: #fff;
    z-index: 101;
    position: relative;

    img {
      width: 1194px;
      height: 730px;
    }

    .banner-title {
      position: absolute;
      color: #CEEFF6;
      top: 23px;
      left: 276px;
      font-size: 22px;
    }

    .data1 {
      width: 111px;
      height: 37px;
      font-size: 12px;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      top: 195px;
      left: 278px;
      text-align: center;
    }

    .data2 {
      width: 111px;
      height: 37px;
      font-size: 12px;
      font-weight: 500;
      color: #FFFFFF;
      position: absolute;
      top: 636px;
      left: 278px;
      text-align: center;
    }

    .data3 {
      width: 111px;
      font-size: 12px;
      position: absolute;
      top: 72px;
      left: 488px;
      text-align: center;
      height: 50px;
    }

    .data4 {
      width: 111px;
      font-size: 12px;
      position: absolute;
      top: 381px;
      left: 493px;
      text-align: center;
      height: 50px;
    }

    .data5 {
      font-size: 12px;
      position: absolute;
      top: 532px;
      left: 489px;
      width: 111px;
      height: 50px;
      text-align: center;
    }

    .data6 {
      font-size: 12px;
      position: absolute;
      top: 647px;
      left: 492px;
      width: 111px;
      height: 50px;
      text-align: center;
    }

    .data7 {
      font-size: 12px;
      position: absolute;
      top: 57px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data8 {
      font-size: 12px;
      position: absolute;
      top: 150px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data9 {
      font-size: 12px;
      position: absolute;
      top: 233px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data10 {
      font-size: 12px;
      position: absolute;
      top: 266px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data11 {
      font-size: 12px;
      position: absolute;
      top: 338px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data12 {
      font-size: 12px;
      position: absolute;
      top: 433px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data13 {
      font-size: 12px;
      position: absolute;
      top: 530px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data14 {
      font-size: 12px;
      position: absolute;
      top: 624px;
      left: 707px;
      width: 180px;
      height: 50px;
      text-align: center;
    }
    .data15 {
      font-size: 12px;
      position: absolute;
      top: 50px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .data16 {
      font-size: 12px;
      position: absolute;
      top: 149px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .data17 {
      font-size: 12px;
      position: absolute;
      top: 240px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .data18 {
      font-size: 12px;
      position: absolute;
      top: 338px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .data19 {
      font-size: 12px;
      position: absolute;
      top: 492px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .data20 {
      font-size: 12px;
      position: absolute;
      top: 583px;
      left: 979px;
      width: 111px;
      height: 50px;
      text-align: center;
    }
    .differPrice1 {
      font-size: 12px;
      position: absolute;
      top: 68px;
      left: 410px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice2 {
      font-size: 12px;
      position: absolute;
      top: 374px;
      left: 410px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice3 {
      font-size: 12px;
      position: absolute;
      top: 520px;
      left: 410px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice4 {
      font-size: 12px;
      position: absolute;
      top: 635px;
      left: 394px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice5 {
      font-size: 12px;
      position: absolute;
      top: 49px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice6 {
      font-size: 12px;
      position: absolute;
      top: 141px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice7 {
      font-size: 12px;
      position: absolute;
      top: 239px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice8 {
      font-size: 12px;
      position: absolute;
      top: 262px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice9 {
      font-size: 12px;
      position: absolute;
      top: 333px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice10 {
      font-size: 12px;
      position: absolute;
      top: 433px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice11 {
      font-size: 12px;
      position: absolute;
      top: 525px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice12 {
      font-size: 12px;
      position: absolute;
      top: 623px;
      left: 626px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice13 {
      font-size: 12px;
      position: absolute;
      top: 47px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice14 {
      font-size: 12px;
      position: absolute;
      top: 142px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice15 {
      font-size: 12px;
      position: absolute;
      top: 228px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice16 {
      font-size: 12px;
      position: absolute;
      top: 326px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice17 {
      font-size: 12px;
      position: absolute;
      top: 476px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }

    .differPrice18 {
      font-size: 12px;
      position: absolute;
      top: 576px;
      left: 898px;
      width: 100px;
      height: 25px;
      text-align: center;
    }
  }

  .redColor {
    color: #FF6969;
  }

  .greenColor {
    color: #43E97B;
  }
}
</style>
